module.exports = __webpack_public_path__ + "static/media/mipa.e0cb8d1b.png";